













class Dad_Joke_Bot {
	readonly name = 'Dad Joke Bot';
	readonly avatar = 'dad-bot';
	readonly description = 'Dad jokes are very punny.';

	async getContent() {
		const request = await fetch('https://icanhazdadjoke.com/', {
			headers: {
				Accept: 'application/json'
			}
		})
		const data = await request.json();
		return data.joke;
	}

	async getMessage() {
		return {
			author: this.name,
			avatar: this.avatar,
			// #N: Note, This should already be a signal that we're heading in the wrong direction.
			// #N: The same class is using a generic and a specific method at the same time.
			content: await this.getContent(),
			time: new Date().toLocaleTimeString(),
		}
	}
}

export default {
	Dad_Joke_Bot: {
		class: Dad_Joke_Bot,
		init: () => new Dad_Joke_Bot(),

	}
}
